<template>

  <div class="user">
    <!--添加任务-->
    <div class="common-seach-wrap">
      <el-form :inline="true" size="small" :model="formInline" class="demo-form-inline">
        <el-form-item label="规则名称">
          <el-input placeholder="请输入规则名称" v-model="formInline.search"></el-input>
        </el-form-item>

        <el-form-item label="类型">
          <el-select v-model="formInline.type" placeholder="类型">
              <el-option label="全部" value=""></el-option>
              <el-option label="用户操作" value="user_op"></el-option>
              <el-option label="发放资金" value="send_capt"></el-option>
              <el-option label="申请" value="apply"></el-option>
            </el-select>
       </el-form-item>

       <el-form-item>
          <el-button type="primary" @click="onSubmit">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="reast">重置</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div class="common-level-rail">
      <el-button size="small" icon="el-icon-plus" type="primary" @click="addClick">添加规则</el-button>
    </div>

    <div class="product-content">
      <el-form ref="form" :model="form" label-width="100px">
        <div class="table-wrap">
          <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
            <el-table-column prop="name" label="规则名称"></el-table-column>
            <el-table-column prop="type" label="分类"> 
              <template slot-scope="scope">
               <div v-if="scope.row.type == 'user_op'">用户操作</div>
               <div v-if="scope.row.type == 'send_capt'">发放资金</div>
               <div v-if="scope.row.type == 'apply'">申请</div>
              </template>
            </el-table-column>
            <el-table-column prop="type" label="操作"> 
              <template slot-scope="scope">
               <div v-if="scope.row.setting.price_type == 'point_add'">增加积分</div>
               <div v-if="scope.row.setting.price_type == 'point_minus'">扣除积分</div>
               <div v-if="scope.row.setting.price_type == 'bancnle_add'">增加联盟币</div>
               <div v-if="scope.row.setting.price_type == 'bancnle_minus'">扣除联盟币</div>
              </template>
            </el-table-column>
            <el-table-column prop="setting.price" label="资金"></el-table-column>
            <el-table-column prop="type" label="操作对象"> 
              <template slot-scope="scope">
                <div v-if="scope.row.obj == 'by'">供应</div>
                <div v-if="scope.row.obj == 'xq'">需求</div>
                <div v-if="scope.row.obj == 'xpfbh'">新品发布会</div>
                <div v-if="scope.row.obj == 'xmtjh'">项目推介会</div>
                <div v-if="scope.row.obj == 'zmlcgd'">招募联创股东</div>
                <div v-if="scope.row.obj == 'tzrfb'">投资人发布</div>
                <div v-if="scope.row.obj == 'relvideo'">发布视频</div>
                <div v-if="scope.row.obj == 'supply_rz'">商户入驻</div>
              
              
              </template>
            </el-table-column>
           

            <el-table-column prop="create_time" label="创建时间" width="150"></el-table-column>
            <el-table-column fixed="right" label="操作" width="90">
              <template slot-scope="scope">
                <el-button @click="editClick(scope.row)" type="text" size="small">编辑</el-button>
                <el-button @click="deleteClick(scope.row)" type="text" size="small">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form>
      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>
    
    <Add :open_add="open_add" v-if="open_add"   @close="closeAdd"></Add>
    <Edit :open_add="open_edit" :rule_id="rule_id"  v-if="open_edit"   @close="closeEdit"></Edit>
  
  </div>
</template>

<script>
  import RuleApi from '@/api/rule.js';
  import Add from './part/add.vue';
  import Edit from './part/edit.vue';
  export default {
    components: {
      Add,
      Edit
    },
    inject: ['reload'],
    data() {
      return {
        /*是否加载完成*/
        loading: true,
        /*列表数据*/
        tableData: [],
        /*一页多少条*/
        pageSize: 20,
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*当前是第几页*/
        curPage: 1,
        /*搜索表单对象*/
        form: {},
        formInline: {
          search:"",
          type:""
        },

        open_add:false,
        open_edit:false,
        rule_id:""
      };
    },
    created() {

      /*获取列表*/
      this.getTableList();
    },
    methods: {
       /*关闭添加*/
    closeAdd(e){
      this.open_add=false;
      this.getTableList();
    },
    closeEdit(e){
      this.open_edit=false;
      this.getTableList();
    },
    reast(){
      this. formInline = {
          search:"",
          type:""
        };
      this.curPage = 1;
      this.getTableList();
    },
    getData(){
      this.curPage = 1;
      this.getTableList();
    },
      /*选择第几页*/
      handleCurrentChange(val) {
        this.curPage = val;
        this.getTableList();
      },

      /*每页多少条*/
      handleSizeChange(val) {
        this.curPage = 1;
        this.pageSize = val;
        this.getTableList();
      },

      /*获取列表*/
      getTableList() {
        let self = this;
        let Params = this.formInline;
        Params.page = self.curPage;
        Params.list_rows = self.pageSize;
        self.loading = true;
        RuleApi.list(Params, true)
          .then(data => {
            self.loading = false;
            self.tableData = data.data.list.data;
            self.totalDataNumber = data.data.list.total;
          })
          .catch(error => {
          });
      },

      /*搜索查询*/
      onSubmit() {
        this.curPage = 1;
        this.getTableList();
      },

      /*添加任务*/
      addClick() {
        this.open_add = true
      },

      /*编辑活动*/
      editClick(row) {
        this.rule_id = row.rule_id;
        this.open_edit = true
      },

      /*删除*/
      deleteClick(row) {
        let self = this;
        self
          .$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
          .then(() => {
            RuleApi.del(
              {
                rule_id: row.rule_id
              },
              true
            )
              .then(data => {
                if (data.code == 1) {
                  self.$message({
                    message: '删除成功',
                    type: 'success'
                  });
                  this.getTableList();
                } else {
                  self.$message.error('错了哦，这是一条错误消息');
                }
              })
              .catch(error => {
              });
          })
          .catch(() => {
          });
      }
    }
  };
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/plus/rule/index.vue